/* ==================================================
   INFINITE OPTIONS — STICKY PRICE SYNC

   Mirrors the Infinite Options Dynamic Bundle Price
   into Horizon's Sticky Add to Cart.

   Normal products are untouched.
   ================================================== */

const IO_PRICE_SELECTOR =
  '.infiniteoptions-price .price-item--regular';

const STICKY_PRICE_SELECTOR =
  '.sticky-add-to-cart__price';

const CUSTOM_PRICE_ATTRIBUTE =
  'data-ko-infinite-sticky-price';

let ioPriceObserver;


/* --------------------------------------------------
   Find the currently visible Infinite Options price
   -------------------------------------------------- */

function getInfiniteOptionsPrice() {
  const prices = [
    ...document.querySelectorAll(IO_PRICE_SELECTOR),
  ];

  if (!prices.length) return null;

  const visiblePrice = prices.find((element) => {
    return (
      element.offsetParent !== null &&
      element.textContent.trim() !== ''
    );
  });

  return visiblePrice || prices[0];
}


/* --------------------------------------------------
   Create/use the custom sticky price
   -------------------------------------------------- */

function getStickyPriceElement() {
  const sticky = document.querySelector(
    STICKY_PRICE_SELECTOR
  );

  if (!sticky) return null;

  let customPrice = sticky.querySelector(
    `[${CUSTOM_PRICE_ATTRIBUTE}]`
  );

  if (customPrice) return customPrice;

  /*
   * Keep Horizon's original price markup intact,
   * but hide it while Infinite Options is active.
   */
  [...sticky.children].forEach((child) => {
    child.style.display = 'none';
  });

  customPrice = document.createElement('span');

  customPrice.setAttribute(
    CUSTOM_PRICE_ATTRIBUTE,
    'true'
  );

  sticky.appendChild(customPrice);

  return customPrice;
}


/* --------------------------------------------------
   Sync price
   -------------------------------------------------- */

function syncInfiniteOptionsStickyPrice() {
  const source = getInfiniteOptionsPrice();

  if (!source) return;

  const target = getStickyPriceElement();

  if (!target) return;

  const price = source.textContent.trim();

  if (!price) return;

  if (target.textContent !== price) {
    target.textContent = price;
  }
}


/* --------------------------------------------------
   Watch Infinite Options for recalculations
   -------------------------------------------------- */

function observeInfiniteOptionsPrice() {
  const priceContainer = document.querySelector(
    '.infiniteoptions-price'
  );

  if (!priceContainer) return;

  ioPriceObserver?.disconnect();

  ioPriceObserver = new MutationObserver(() => {
    syncInfiniteOptionsStickyPrice();
  });

  ioPriceObserver.observe(priceContainer, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  syncInfiniteOptionsStickyPrice();
}


/* --------------------------------------------------
   Infinite Options may update asynchronously
   -------------------------------------------------- */

function schedulePriceSync() {
  [0, 50, 150, 300, 600].forEach((delay) => {
    window.setTimeout(() => {
      observeInfiniteOptionsPrice();
      syncInfiniteOptionsStickyPrice();
    }, delay);
  });
}


/* --------------------------------------------------
   Initialize
   -------------------------------------------------- */

function initializeInfiniteOptionsStickyPrice() {
  if (
    !document.querySelector('.infiniteoptions-price')
  ) {
    return;
  }

  observeInfiniteOptionsPrice();

  document.addEventListener(
    'change',
    schedulePriceSync,
    true
  );

  document.addEventListener(
    'input',
    schedulePriceSync,
    true
  );
}


if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeInfiniteOptionsStickyPrice,
    { once: true }
  );
} else {
  initializeInfiniteOptionsStickyPrice();
}


/* Shopify theme editor support */

document.addEventListener(
  'shopify:section:load',
  () => {
    observeInfiniteOptionsPrice();
    syncInfiniteOptionsStickyPrice();
  }
);